<template>
  <div class="available-documents-main-view width-responsiveness">
    <subheader class="alternative-subheader alternative-subheader__limit-width">
      <div
        slot="filter-labels"
        class="search-title"
      >
        <h2>
          <span>Documentos disponíveis</span>
        </h2>
      </div>

      <div class="subheader-alternative-actions-container">
        <div
          class="subheader-actions-container__turn-back position-right"
          @click="navigateToSearch"
        />
      </div>
    </subheader>
    <template v-if="loadingStatus === 'STATUS_FINISHED'">
      <template v-if="total > 0">
        <div class="available-documents-main-view__left-side">
          <card title="Resumo">
            <count-icon
              :content="{
                number: total,
                text: 'Documentos Encontrados',
                color: 'blue',
                icon: 'doc-list',
              }"
            />
          </card>
        </div>

        <div class="available-documents-main-view__middle-side">
          <available-documents-data-table :documents="documents" />
        </div>
      </template>
      <div
        v-else
        class="empty-search"
      >
        <md-icon md-src="/static/images/icon-no-tubes-found.svg" />
        <p>Não encontramos nenhum resultado para sua busca.</p>
      </div>
    </template>

    <div
      v-else
      class="available-documents-main-view__middle-side"
    >
      <spinner class="loader-table" />
    </div>
  </div>
</template>

<script>
import CountIndicator from '@/components/Dashboard/Widgets/CountIndicator'
import CountIcon from '../common/dataTable/CountIcon'
import Card from '@/components/Dashboard/Card'
import SubHeader from '../common/SubHeader'
import AvailableDocumentsDataTable from './AvailableDocumentsDataTable'
import Spinner from '../common/Spinner'
import documentManagementService from '@/api/documentManagement'
import notify from '@/api/notification'
import { groupObjectByKey } from '@/utils/groupObjectByKey'
import { mapActions } from 'vuex'

export default {
  name: 'AvailableDocumentsMainView',
  components: {
    'count-indicator': CountIndicator,
    'count-icon': CountIcon,
    card: Card,
    subheader: SubHeader,
    'available-documents-data-table': AvailableDocumentsDataTable,
    spinner: Spinner,
  },
  data() {
    return {
      documents: {},
      total: 0,
      loadingStatus: 'STATUS_INITIAL',
    }
  },
  created() {
    this.getAllDocuments()
  },
  methods: {
    ...mapActions(['resetTraceabilityStore']),
    navigateToSearch() {
      this.$router.push('/traceability/search')
    },
    getAllDocuments() {
      this.loadingStatus = 'STATUS_LOADING'
      this.documents = []
      documentManagementService
        .getAllExamsAndDocumentsLinked()
        .then(response => {
          this.groupDocumentsByName(response.data)
          this.loadingStatus = 'STATUS_FINISHED'

          this.total = Object.keys(this.documents).length
        })
        .catch(() => {
          notify({
            title: 'AVISO:',
            message: 'Não foi possível carregar os documentos.',
          })
          this.loadingStatus = 'STATUS_FINISHED'
        })
    },
    groupDocumentsByName(list) {
      this.documents = groupObjectByKey(list, 'fileName')
    },
  },
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/variables';

.available-documents-main-view {
  height: 100vh;
  padding-top: $mainHeaderHeight;
  margin-top: 3em;
  display: flex;
  flex-direction: row;

  .loader-table {
    margin-top: 20%;
    margin-left: 57%;
  }

  .empty-search {
    width: 20%;
    position: relative;
    top: 35%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: auto;

    .md-icon {
      width: 50px;
      height: 50px;
      margin-bottom: 1em;
      margin-left: 35%;
    }

    p {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #7a7a7a;
    }
  }

  .search-title {
    display: flex;

    .md-icon {
      cursor: pointer;
      margin-right: 0.7em;
    }
  }

  .subheader__content__right-side {
    display: flex;

    .subheader-alternative-actions-container {
      position: inherit;
    }

    p {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #7a7a7a;
      margin: auto;
    }
  }

  &__left-side {
    width: 20%;
    margin-top: 3em;
    .md-card {
      background-color: white;
      margin-top: 4.3em;
      height: 110px;
      background: 79% 30px;
      .count-icon {
        margin-top: 0.6em;
        &__count p {
          font-size: 32px;
          line-height: 26px;
        }
        &__description h2 {
          font-size: 12px;
          line-height: 14px;

          @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
            /* IE10 & IE11 CSS styles go here */
            margin-top: 0.3em;
          }
        }
      }
    }
  }

  &__middle-side {
    margin-left: 2em;
    width: 78%;
    margin-top: 2em;

    h2 {
      font-size: 22px;
      font-weight: 400;
      letter-spacing: -0.3px;
      text-align: left;
      color: #7a7a7a;
      line-height: 1.09;
    }

    .btn-small {
      letter-spacing: 1px;
    }
  }
}
</style>
